"use strict";

import { createStore } from "vuex";
import auth from "./auth/index.js";
import users from "./users/index.js";
import subscriptions from "./subscriptions/index.js";
import transactions from "./transactions/index.js";
import products from "./products/index.js";
import members from "./members/index.js";

const store = createStore({
  state() {
    return {
      user: null,
    };
  },

  getters: {
    user(state) {
      return state.user;
    },
  },

  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
  },

  modules: {
    auth,
    users,
    subscriptions,
    transactions,
    products,
    members,
  },
});

export default store;
